module.exports = __webpack_public_path__ + "static/img/lectureOne.16f4b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lectureOne.png
// module id = +NWZ
// module chunks = 1